import axios from "axios";
import { useEffect, useState } from "react";
import { getHost } from "../helpers/getHost";

export default function useRegister(user) {
  const [userId, setUserId] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userName, setUserName] = useState("");
  const [actionState, setActionState] = useState({ status: 204, error: null });
  const [submitted, setSubmitted] = useState(false);
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    const getCustomer = async () => {
      try {
        const res = await axios.get(
          `${getHost()}/api/signup?userEmail=${user.email}`,
          {
            headers: {
              Authorization: user.accessToken,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );
        if (res.status !== 200) {
          throw new Error(`${res.status} ${res.statusText}`);
        } else {
          setUserEmail(res.data[0].userEmail);
          setUserId(res.data[0].userId);
          setUserName(res.data[0].userEmail);
        }
      } catch (err) {
        console.warn(err.response);
      }
    };
    getCustomer();
  }, [user]);

  const [vendor, setVendor] = useState({
    businessID: `${Date.now()}`,
    firstName: "",
    lastName: "",
    businessName: "",
    address: "",
    city: "",
    state: "",
    email: "",
    businessPhone: "",
    category: "",
  });

  //Merge vendor filled form Object with identifying data for querying
  const formData = Object.assign(vendor, {
    userId: userId,
    userEmail: userEmail,
    userName: userName,
    clientUID: user.uid,
  });

  const uid = {
    clientUID: user?.uid,
  };

  //Submit form to update
  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    axios
      .post(`${getHost()}/api/register`, formData, {
        headers: {
          Authorization: user.accessToken,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        console.log(res.status);
      })
      .catch((error) => {
        console.warn(error.message);
      });

    axios
      .post(
        `${getHost()}/api/signup/add-client?userEmail=${user?.email}`,
        uid,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        setActionState({ status: res.status, error: null });
      })
      .catch((err) => {
        setActionState({ status: 500, error: err });
      });
  };

  return {
    setVendor,
    setShowToast,
    handleSubmit,
    userId,
    userEmail,
    userName,
    vendor,
    actionState,
    submitted,
    showToast,
  };
}
